module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAIAAACQkWg2AAAABnRSTlMAAAAAAABupgeRAAABLUlEQVR4AWOgD5hkTyTCpmGCI8NEh5TVyqmrlYEMIBePBgeGPme1OaYrNotcXyh6faHYqi0iGnNMgYJAKQwNE5wYJzrkrFS5u40r39NPgbdQhiMv29nn3nauvFXKTCCrnBAagHzTOca7tgv8P82waVqgf8TctJSZkRETVKSb2+PM/59n2LNdwGyOEUgbBOjMMn11kOX/SQYgSvIIUxKuMFIqc7NtikyY1VyW9+8oSPzNQWbdWSYIG8znGO3dwQ80rD/DRoavTluySF2kQIq7dmmr7/9zDPt28FuAbED1A/NE+/xVyve3ceV5+CsJFKuKlBb7hdzZxFmwWhkoBVSAEUoTQaEEDJZVm0WuLRC7Ol9s9WYRrTkmQEGgFIF4SFujnLFGiWES7nggFg1KAAAbEJv8UkvKxwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/BR.png
// module id = 1097
// module chunks = 0